import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { useTranslation } from '@/hooks/useTranslation';
import React from 'react';
import { AppSidebar } from './ProtectedPagesLayout/index';
import type { ProtectedPagesLayoutProps } from './ProtectedPagesLayout/types';

/**
 * Layout component for protected pages with responsive sidebar.
 *
 * Features:
 * - Permission-based navigation filtering
 * - Icon-collapsible sidebar with groups (toggle in the sidebar header,
 *   or Cmd/Ctrl+B). Language and theme controls live in the sidebar footer.
 * - User authentication state
 * - Responsive design
 * - Accessibility compliant
 *
 * @param children - The page content to render inside the layout
 */
export const ProtectedPagesLayout: React.FC<ProtectedPagesLayoutProps> = ({
  children,
}) => {
  const { t } = useTranslation();

  return (
    <SidebarProvider>
      <div className='flex min-h-screen w-full'>
        <AppSidebar />
        <SidebarInset>
          <main
            className='flex flex-1 flex-col gap-4 p-4'
            role='main'
            aria-label={t('layout.mainContent')}
          >
            {children}
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default ProtectedPagesLayout;
